import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconUsers } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { close as closeParticipantsPane, open as openParticipantsPane } from '../../../participants-pane/actions.web';
import { closeOverflowMenuIfOpen } from '../../../toolbox/actions.web';
import { isParticipantsPaneEnabled } from '../../functions';
import ParticipantsCounter from './ParticipantsCounter';
import { closeChat } from "../../../chat/actions.web";
/**
 * Implementation of a button for accessing participants pane.
 */
class ParticipantsPaneButton extends AbstractButton {
    /**
     * Initializes a new {@code ParticipantsPaneButton} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.participants';
        this.toggledAccessibilityLabel = 'toolbar.accessibilityLabel.closeParticipantsPane';
        this.icon = IconUsers;
        this.label = 'toolbar.participants';
        this.state = {
            isHovered: false
        };
        // Bind event handlers so they are only bound once for every instance.
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isOpen;
    }
    /**
     * Indicates whether this button is in disabled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isDisabled() {
        return this.props._lobbyKnocking;
    }
    /**
     * Handles clicking the button, and toggles the participants pane.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch, _isOpen, _isChatOpen } = this.props;
        dispatch(closeOverflowMenuIfOpen());
        if (_isOpen) {
            dispatch(closeParticipantsPane());
        }
        else {
            if (_isChatOpen) {
                dispatch(closeChat());
            }
            dispatch(openParticipantsPane());
        }
    }
    /**
     * Button is being hovered.
     *
     * @param {MouseEvent} e - The mouse down event.
     * @returns {void}
     */
    _onMouseEnter() {
        this.setState({
            isHovered: true
        });
    }
    /**
     * Button is not being hovered.
     *
     * @returns {void}
     */
    _onMouseLeave() {
        if (this.state.isHovered) {
            this.setState({
                isHovered: false
            });
        }
    }
    /**
     * Overrides AbstractButton's {@link Component#render()}.
     *
     * @override
     * @protected
     * @returns {React$Node}
     */
    render() {
        const { _isParticipantsPaneEnabled, _isOpen } = this.props;
        const { isHovered } = this.state;
        if (!_isParticipantsPaneEnabled) {
            return null;
        }
        return (React.createElement("div", { className: 'toolbar-button-with-badge', onMouseLeave: () => this._onMouseLeave(), onMouseEnter: () => this._onMouseEnter() },
            super.render(),
            React.createElement(ParticipantsCounter, { visible: !this._isDisabled() && (_isOpen || isHovered) })));
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {IProps}
 */
function mapStateToProps(state) {
    const { isOpen } = state['features/participants-pane'];
    const _isChatOpen = state['features/chat'].isOpen;
    const { knocking } = state['features/lobby'];
    return {
        _isOpen: isOpen,
        _isChatOpen: _isChatOpen,
        _isParticipantsPaneEnabled: isParticipantsPaneEnabled(state),
        _lobbyKnocking: knocking
    };
}
export default translate(connect(mapStateToProps)(ParticipantsPaneButton));
